export const UNABLE_TO_UPDATE_INFORMATION_ERROR_MESSAGE =
    'Unable to update information to event. Try again later';
export const CANNOT_UPDATE_UNLESS_ASSIGNED_ERROR_MESSAGE =
    'Cannot update unless assigned to an event';
